import React from 'react';
import PropTypes from 'prop-types';

import Drm from 'Components/Utility/Drm';
import useViewport from 'Hooks/useViewport';
import env from 'Env';

import 'Components/Product/DrmBanner/DrmBanner.scss';

export default function DrmBanner({ drm, steamReviewSummary }) {
  const { isBelowMd } = useViewport();

  if (!drm) return false;

  const steamThreshold = env.steamPercentThreshold;
  let steamReviewScore = 0;

  const steamReviewScoreDesc = steamReviewSummary?.review_score_desc;

  if (steamReviewSummary) {
    steamReviewScore =
      Math.round((steamReviewSummary.total_positive / steamReviewSummary.total_reviews) * 100);
  }

  const showSteamReviewScore = steamReviewScore >= steamThreshold && drm === 'steam';


  return (
    <section className={`DrmBanner DrmBanner--${drm}`}>
      <Drm drmType={drm} colorOverride="light" iconSize={isBelowMd ? 'small' : ''} />

      {showSteamReviewScore &&
        <div className="DrmBanner__steam">
          <div>
            {steamReviewScore}%&nbsp;|&nbsp;{steamReviewScoreDesc}
          </div>
        </div>
      }

    </section>
  );
}

DrmBanner.propTypes = {
  drm: PropTypes.string,
  steamReviewSummary: PropTypes.shape({}),
};

DrmBanner.defaultProps = {
  drm: '',
  steamReviewSummary: null,
};
